import {
    createSupportTicketRequest,
    fetchPreferredIdentifierMethodsRequest,
    getAllCommonsRequest,
    refreshBasicDataRequest,
    sendFeedbackMessageRequest,
} from "../commons.service";
import {
    authenticationReducerActions,
    clientReducerActions,
    commonsReducerActions,
    myOrganizationReducerActions,
} from "../../../_services/store";
import stringUtils from "../../../_services/string-utils";
import { buildNavigationUpdateAction } from "../../../_services/store/navigation.utils";
import { alertActions } from "../../../_services/store/alert.actions";
import { getHubspotVisitorToken } from "../../../user/services/store/authentication.actions";
import { initializeProductFruitsUser } from "../../../organization/myOrganization/services/store/myOrganization.actions";
import { E2E_TAX_CONSULTANT_EMAIL } from "../../../admin/components/OrganizationContent";
import { userService } from "../../../user/services/user.service";

export const refreshBasicData = () => {
    return async (dispatch) => {
        dispatch(commonsReducerActions.getAllCommonsRequest());
        dispatch(authenticationReducerActions.reloadUserRequest());
        dispatch(clientReducerActions.getClientsForSelectedOrganizationRequest());
        dispatch(commonsReducerActions.setBasicDataErrorMessage(null));
        dispatch(commonsReducerActions.toggleBasicDataLoading());
        try {
            let response = await refreshBasicDataRequest();
            if (response) {
                if (
                    response.user &&
                    !stringUtils.isBlank(response.user.errorMessage) &&
                    response.user.errorMessage.length > 0
                ) {
                    dispatch(authenticationReducerActions.reloadUserFailure(response.user.data.errorMessage));
                    dispatch(commonsReducerActions.setBasicDataErrorMessage(response.user.data.errorMessage));
                } else {
                    let user = response.user.response;
                    dispatch(myOrganizationReducerActions.setProductFruitsChecklists(null));
                    dispatch(myOrganizationReducerActions.setProductFruitsUser(null));
                    dispatch(authenticationReducerActions.updateLoggedInUserSuccess(user));

                    if (
                        user.showProductFruits && user.selectedOrganization &&
                        (!user.mail.includes("e2e") && !stringUtils.equals(E2E_TAX_CONSULTANT_EMAIL, user.mail))
                    ) {
                        dispatch(initializeProductFruitsUser(user));
                    }
                    dispatch(buildNavigationUpdateAction(user));
                    if (!user.hubspotVisitorToken) {
                        try {
                            dispatch(getHubspotVisitorToken(user));
                        } catch (error) {
                            dispatch(authenticationReducerActions.reloadUserFailure(error));
                            dispatch(commonsReducerActions.setBasicDataErrorMessage(error));
                        }
                    }
                    dispatch(buildNavigationUpdateAction(user));
                    await userService.mergeUserIntoStorage(user);
                }

                if (
                    response.clients &&
                    !stringUtils.isBlank(response.clients.errorMessage) &&
                    response.clients.errorMessage.length > 0
                ) {
                    dispatch(
                        clientReducerActions.getClientsForSelectedOrganizationFailure(response.clients.errorMessage)
                    );
                    dispatch(commonsReducerActions.setBasicDataErrorMessage(response.clients.errorMessage));
                } else {
                    dispatch(clientReducerActions.getClientsForSelectedOrganizationSuccess(response.clients.response));
                }

                if (
                    response.commons &&
                    !stringUtils.isBlank(response.commons.errorMessage) &&
                    response.commons.errorMessage.length > 0
                ) {
                    dispatch(commonsReducerActions.getAllCommonsFailure(response.commons.errorMessage));
                    dispatch(commonsReducerActions.setBasicDataErrorMessage(response.commons.errorMessage));
                } else {
                    dispatch(commonsReducerActions.getAllCommonsSuccess(response.commons.response));
                }

                dispatch(commonsReducerActions.setSidebarBadges(response.sidebarBadges || null));
            } else {
                const error = "Es ist ein Unbekannter Fehler aufgetreten.";
                dispatch(authenticationReducerActions.reloadUserFailure(error));
                dispatch(clientReducerActions.getClientsForSelectedOrganizationFailure(error));
                dispatch(commonsReducerActions.getAllCommonsFailure(error));
                dispatch(commonsReducerActions.setBasicDataErrorMessage(error));
            }
        } catch (error) {
            dispatch(authenticationReducerActions.reloadUserFailure(error));
            dispatch(clientReducerActions.getClientsForSelectedOrganizationFailure(error));
            dispatch(commonsReducerActions.getAllCommonsFailure(error));
            dispatch(commonsReducerActions.setBasicDataErrorMessage(error));
        }
        dispatch(commonsReducerActions.toggleBasicDataLoading());
    };
};

export const getAllCommons = () => {
    return async (dispatch) => {
        dispatch(commonsReducerActions.getAllCommonsRequest());
        try {
            const commons = await getAllCommonsRequest();
            dispatch(commonsReducerActions.getAllCommonsSuccess(commons));
        } catch (error) {
            dispatch(commonsReducerActions.getAllCommonsFailure(error));
        }
    };
};

export const sendFeedbackMessage = (message) => {
    return async (dispatch) => {
        dispatch(commonsReducerActions.sendFeedbackMessageRequest());
        try {
            const response = await sendFeedbackMessageRequest(message);
            dispatch(
                alertActions.generalSuccessAndClear(
                    "Vielen Dank für dein Feedback! Solltest du ein Problem gemeldet haben, setzen wir uns schnellstmöglich mit dir in Verbindung.",
                    3000
                )
            );
            dispatch(commonsReducerActions.sendFeedbackMessageSuccess(response));
        } catch (error) {
            dispatch(commonsReducerActions.sendFeedbackMessageFailure(error));
        }
    };
};

export const fetchPreferredIdentifierMethods = (integration) => {
    return async (dispatch) => {
        dispatch(commonsReducerActions.fetchPreferredIdentifierMethodsRequest());
        try {
            const response = await fetchPreferredIdentifierMethodsRequest(integration);
            dispatch(commonsReducerActions.fetchPreferredIdentifierMethodsSuccess(response));
            return response;
        } catch (error) {
            dispatch(commonsReducerActions.fetchPreferredIdentifierMethodsFailure(error));
        }
    };
};

export const createSupportTicket = (payload) => {
    return async () => {
        try {
            const response = await createSupportTicketRequest(payload);
            return response.data;
        } catch (error) {
            // TODO: error handling
        }
    };
};
